import { activities } from '@/externals/gyym/user'
import { ActivityId } from '@/externals/gyym/user/activities'
import { cacheableAction } from '@/utils/cacheableAction'
import { activitySlugMap, activitySlugs } from './constants'
import { ActivitySlug } from './types'
import { sortActivities } from './utils'

const listActivitiesAction = cacheableAction(async () => {
  const data = await activities.list()
  return sortActivities(data)
})

export const listActivities = listActivitiesAction.withCache('activities_v1', {
  expiresAfter: 1000 * 60 * 10,
})

export const getActivity = async (activityId: ActivityId) =>
  await activities.get(activityId)

export const activitySlugExists = (slug: string) => {
  return activitySlugs.includes(slug as ActivitySlug)
}

export const getActivityIdBySlug = (slug: string): ActivityId | null => {
  return activitySlugMap[slug as ActivitySlug] ?? null
}

export const getActivityBySlug = async (slug: string) => {
  const data = await listActivities()
  return data.find(
    (activity) => activity.id === activitySlugMap[slug as ActivitySlug]
  )
}

export const getActivitySlugById = (activityId: ActivityId) => {
  const entry = Object.entries(activitySlugMap).find(
    ([_, v]) => v === activityId
  )

  return entry ? entry[0] : null
}
